module.exports = __webpack_public_path__ + "img/logo_15.3fee5c85.png";